import { SendLoanProposal } from "../../service/controller/LoanController";
import { getCookie } from "../../util/Cookie";
import { LoanActionType } from "./action-type";

var user_data = getCookie("user_data");
const userState = (user_data && user_data !== undefined && user_data != null) ? JSON.parse(user_data ?? "{}") : null

const initialState = {
    user: userState
}

const loanReducer = (state = initialState, action) => {
    const request = action.payload;
    if (action.type === LoanActionType.SEND_PROPOSAL) {
        SendLoanProposal(request, response => {
            action.callBack(response);
        });
    }
    return state;
}

export default loanReducer;